/* eslint-disable import/no-dynamic-require */
import loadRequire from './loadRequire';

let promise;

export default function loadXlsx() {
  if (promise) {
    return promise;
  }
  promise = loadRequire().then((require) => {
    return new Promise((resolve) => {
      require(['xlsx'], resolve);
    });
  });
  return promise;
}
